// removed by extract-text-webpack-plugin
module.exports = {"vpSubmitResponseButton":"vpSubmitResponseButton___1lHcs","vpLoadingSpinner":"vpLoadingSpinner___CowMl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/SubmitResponseButton.module.less
// module id = 3620
// module chunks = 29